export const AuthShell = ({ children, title, subtitle }) => (
  <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-white">
    <div className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-[#258F00] p-12 text-white">
      <div className="syc-grid-bg absolute inset-0 opacity-25" />
      <div className="relative flex items-center gap-3">
        <div className="syc-logo !bg-white !text-[#258F00]">S&amp;C</div>
        <span className="font-extrabold tracking-[0.12em]">SYC CONTROL</span>
      </div>
      <div className="relative max-w-md">
        <div className="mb-4 h-1.5 w-16 rounded-full bg-[#5CD500]" />
        <h2 className="text-4xl font-extrabold leading-tight">SYC Control, plataforma interna de gestión.</h2>
        <p className="mt-4 text-white/80 text-sm">Gerencia · RR.HH. · Operaciones · Abastecimiento · Prevención · Compras · Flota · ISO</p>
      </div>
      <div className="relative text-xs text-white/60">Acceso restringido a personal autorizado. Toda actividad queda registrada.</div>
    </div>
    <div className="flex items-center justify-center p-6 sm:p-12 bg-[#F7F7F7] lg:bg-white">
      <div className="w-full max-w-md syc-rise">
        <div className="lg:hidden flex items-center gap-3 mb-8">
          <div className="syc-logo">S&amp;C</div>
          <span className="font-extrabold tracking-[0.12em] text-[#258F00]">SYC CONTROL</span>
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#5b6656] mt-2 mb-8">{subtitle}</p>}
        {children}
      </div>
    </div>
  </div>
);
